<span>{{ 'Category::MigrationCompletedMessage' | abpLocalization }}</span>
